var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgList = function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0m10 2h-6a2 2 0 0 1 0-4h6a2 2 0 0 1 0 4M6 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0m4 2h6a2 2 0 0 0 0-4h-6a2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgList;